export default __webpack_public_path__ + "static/media/seasonalCat.9244423a.jpg";